import LocationSelect from '@/components/location-select/index.vue';
import Service from '../service';
import regExp from '@/utils/regExp.js';
import { mapGetters } from 'vuex';
import { getQRCode } from '@/utils/common.js';
const debounce = require('lodash.debounce');

export default {
  components: {
    LocationSelect
  },
  data() {
    return {
      showDialog: false,
      queryParams: {},
      details: {
        fundInfo: {},
        product: {}
      },
      userInfo: {},
      show1: false,
      form1: {
        realname: '',
        IDCard: '',
        source: 'wechat'
      },
      rules1: {
        realname: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        IDCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: regExp.idCard, message: '请输入正确的身份证号', trigger: 'blur' }
        ]
      },
      show3: false,
      show2: false,
      loanCreditList: [],
      loanTermList: [],
      captchaImageSrc: '',
      time: null,
      timer: null,
      form2: {
        pId: '',
        fund: '',
        amount: '', // 元
        loanTerm: '', // 60
        username: '',
        IDCard: '',
        userMobile: '',
        ticket: '',
        captcha: '',
        smsCode: '',
        area: ''
      },
      rules2: {
        amount: [
          { required: true, message: '请选择贷款额度', trigger: 'blur' }
        ],
        loanTerm: [
          { required: true, message: '请选择贷款期限', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入申请人姓名', trigger: 'blur' }
        ],
        IDCard: [
          { required: true, message: '申请人身份证号', trigger: 'blur' },
          { pattern: regExp.idCard, message: '请输入正确的身份证号', trigger: 'blur' }
        ],
        userMobile: [
          { required: true, message: '请输入申请人手机号', trigger: 'blur' },
          { pattern: regExp.phone, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入手机验证码', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请选择申请人地址', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'getTenantParams'
    ])
  },
  created() {
    this.queryParams = this.$route.query;
    this.getDetails();
    // this.updateCaptchImage();
  },
  methods: {
    getQRCode,
    getDetails() {
      Service.getProductList({ homePage: 10, limit: 100 }).then(res => {
        const arr = res.result;
        if (arr) this.details = arr.filter(item => item._id === this.queryParams.id)[0];
        this.setSelectOption();
      });
    },
    setSelectOption() {
      const arrList_1 = this.details.loanCredit.split('~');
      for (let i = arrList_1[0]; i <= arrList_1[1]; i++) {
        this.loanCreditList.push({
          label: i + '万',
          value: i * 10000
        });
      }
      for (let i = 1; i <= this.details.borrowPeriod; i++) {
        this.loanTermList.push({
          label: i + '个月',
          value: i
        });
      }
    },
    updateCaptchImage() {
      Service.getCaptchaImage().then((res) => {
        this.captchaImageSrc = res.content;
        this.form2.ticket = res.ticket;
      }).catch(() => {
        this.captchaImageSrc = '';
        this.form2.ticket = '';
      });
    },
    sendMessage: debounce(function () {
      const postData = {
        mobile: this.form2.userMobile,
        ticket: this.form2.ticket,
        captcha: this.form2.captcha,
        clientid: '66ab2ef7247b9fffdb5eba16'
      };
      if (!postData.mobile) {
        this.$errorMessage('请输入手机号码！');
        return false;
      }
      if (!regExp.phone.test(postData.mobile)) {
        this.$errorMessage('请输入正确的手机号码！');
        return false;
      }
      if (!postData.captcha) {
        this.$errorMessage('请输入图片密码！');
        return false;
      }
      Service.sendSmsByMobile(postData).then(({ data }) => {
        console.log(111, data);
        this.setTime();
      });
    }, 1000, {
      'leading': true,
      'trailing': false
    }),
    setTime() {
      this.time = 60;
      this.timer = setInterval(() => {
        this.time -= 1;
        if (this.time === 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    areaCodeChange(event) {
      this.form2.area = event.areaCode;
    },
    // 获取数字的方法
    extractNumbers() {
      if (this.details.totalRateDesc) {
        const numbers = this.details.totalRateDesc.match(regExp.amount);
        console.log(numbers);  // 打印提取到的数字
        return numbers;

      }
      return [];
    },
    apply() {
      this.$store.commit('SET_APP_QR_CODE_SHOW', 'finance');
      // Service.getUserDetails({showIdentity: true, unsafe: true}).then(res => {
      //   this.userInfo = res;
      //   if (this.userInfo.identified) {
      //     this.show2 = true;
      //     this.updateCaptchImage();
      //   } else {
      //     this.show1 = true;
      //     this.form1.realname = '';
      //     this.form1.IDCard = '';
      //   }
      // });
    },
    submit1() {
      this.$refs.ruleForm1.validate((valid) => {
        if (valid) {
          Service.userIdentity(this.form1).then(() => {
            this.show1 = false;
            this.$successMessage('实名成功');
          }).catch(error => {
            if (error && error.data && error.data.reason) {
              this.$errorMessage(error.data.reason);
            } else {
              this.$errorMessage('实名失败');
            }
          });
        }
      });
    },
    close1() {
      this.show1 = false;
    },
    submit2() {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          this.$confirm('您确认提交吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.form2.pId = this.details._id;
            this.form2.fund = this.details.fund._id;
            Service.createOrder(this.form2).then(() => {
              this.$router.back();
            });
          }).catch(() => {
          });
        }
      });
    },
    close2() {
      this.$router.back();
    }
  }
};
